@for (group of orderDetailsGroups; track group) {
  <div class="p-4 shadow" style="margin-bottom: 40px; background-color: white;">
    <h1 class="text-center">{{ group.title || "Default Group Name" }}</h1>

    <button 
      class="btn btn-primary float-right" 
      style="margin-top: -40px; position: absolute; right: 28%;" 
      (click)="autofillFieldsTemporary()"
      *ngIf="group.title === 'Order details' && !isProduction"
    >
      Autofill
    </button>

    <p class="text-center">{{ group.helpText }}</p>
    <form [formGroup]="form">
      <div *ngFor="let detail of group.fields">
        <div
          *ngIf="detail.isVisible && !detail.isHidden"
          class="form-group mb-3"
        >
          <label
            >{{ detail.name }} <span *ngIf="detail.isRequired">*</span></label
          >

          <!-- Render input based on componentType -->
          <ng-container [ngSwitch]="detail.componentType">
            <!-- Text Field -->
            <input
              *ngSwitchCase="'Text'"
              type="text"
              class="form-control"
              [formControlName]="detail.name"
              (focus)="showHelpText(detail.orderDetailFieldId)"
              (blur)="hideHelpText(detail.orderDetailFieldId)"
            />

            <!-- Select Field -->
            <select
              *ngSwitchCase="'Select'"
              class="form-control custom-select"
              [formControlName]="detail.name"
              (focus)="showHelpText(detail.orderDetailFieldId)"
              (blur)="hideHelpText(detail.orderDetailFieldId)"
            >
              <option
                *ngFor="let value of detail.values"
                [value]="value.value"
              >
                {{ value.value }}
              </option>
            </select>

            <!-- RadioButton Field -->
            <div *ngSwitchCase="'RadioButton'">
              <div
                *ngFor="let value of detail.values"
                class="form-check form-check-inline"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  [value]="value.value"
                  [formControlName]="detail.name"
                  (focus)="showHelpText(detail.orderDetailFieldId)"
                  (blur)="hideHelpText(detail.orderDetailFieldId)"
                />
                <label class="form-check-label">{{ value.value }}</label>
              </div>
            </div>

            <!-- DateTime Field -->
            <input
              *ngSwitchCase="'DateTime'"
              type="date"
              class="form-control"
              [formControlName]="detail.name"
              (focus)="showHelpText(detail.orderDetailFieldId)"
              (blur)="hideHelpText(detail.orderDetailFieldId)"
            />
          </ng-container>

          <!-- Help Text -->
          <div
            *ngIf="detail.helpText"
            [ngClass]="{
              'd-none': !isHelpTextVisible(detail.orderDetailFieldId),
            }"
            class="help-text mt-2 text-center"
          >
            {{ detail.helpText }}
          </div>

          <!-- Display validation errors -->
          <div
            *ngIf="
              form.get(detail.name)?.hasError('required') &&
              (form.get(detail.name)?.touched || form.get(detail.name)?.dirty)
            "
            class="text-danger"
          >
            {{ detail.name }} is required.
          </div>
        </div>
      </div>
    </form>
  </div>
}
